import { Http } from "@Services";
import { IUpdateSettingsResponse, IUserUpdateData } from "@Interfaces";

const updateUserData = async (
    data: IUserUpdateData
): Promise<IUpdateSettingsResponse> => {
    let response: IUpdateSettingsResponse;
    try {
        response = await Http.Request<IUpdateSettingsResponse>({
            method: "PATCH",
            url: `/users`,
            data,
        });
    } catch (error) {
        //  @ts-ignore
        throw Error(error.response.data.message);
    }
    return response;
};

export default updateUserData;
